export var LEGACY_URL='/orders_legacy';export var ORDERS_PATH='/orders';